import React from 'react'
import { useSelector } from 'react-redux'
import SetInnerHtml from './SetInnerHtml'

export default function Required() {
  const data = useSelector((state) => state.generalData)
  return (
    <div className="row">
      <div className="col-sm-12 footnote text-end">
        <SetInnerHtml tag="span" content={data.html_requirednote} />
      </div>
      <br />
    </div>
  )
}
